import React, { createContext, useContext, useState } from 'react';
import { AlertResultsContext } from '../AlertResultsProvider';
import { MatchType, VarianceType } from '../types/AlertResults';

type FiltersContextValue = {
  filtersCount: number;
  collapsed: boolean;
  resetForm: () => void;
  toggleCollapsed: () => void;
};

export const FiltersContext = createContext<FiltersContextValue>({
  filtersCount: 0,
  collapsed: true,
  resetForm: () => {},
  toggleCollapsed: () => {},
});

export const FiltersContextProvider: React.FC = ({ children }) => {
  const { sidebarFilters, clearSidebarFilters } = useContext(AlertResultsContext);
  const [collapsed, setCollapsed] = useState(true);

  const value: FiltersContextValue = {
    filtersCount: Object.entries(sidebarFilters).filter(([key, value]) => {
      if (key === 'matchType' && value === MatchType.ALL) {
        return false;
      }
      if (key === 'priceType' && value === VarianceType.Lowest) {
        return false;
      }
      return !!value;
    }).length,
    collapsed,
    resetForm: () => {
      clearSidebarFilters();
    },
    toggleCollapsed: () => setCollapsed((prev) => !prev),
  };

  return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>;
};
